import { render, staticRenderFns } from "./Playlistpage.vue?vue&type=template&id=1ddde5da"
import script from "./Playlistpage.vue?vue&type=script&lang=js"
export * from "./Playlistpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports